import React from 'react';
import { Trans } from 'react-i18next';
import { IInviteMessage } from '../InviteMembersModal.d';
import TrackLink from '../../../utils/trackLink';

const WhatsAppButton = ({
  shareMessage,
}: // eslint-disable-next-line no-shadow
Pick<IInviteMessage, 'shareMessage'>) => (
  <TrackLink
    target="_blank"
    rel="noopener noreferrer"
    className="jg-btn jg-btn--whatsapp jg-h4 jg-space-mbms"
    href={`https://wa.me/?text=${shareMessage}`}
    trackingData={{
      action_name: 'link click',
      subtype: 'invite',
      event: 'link click',
      event_value: 'whatsapp',
      page_section: 'invite team members',
    }}
  >
    <Trans i18nKey="share.button.whatsapp" />
  </TrackLink>
);

export default WhatsAppButton;
